<template>
    <div>
            <div class="price-box" v-if="!hidePriceBox">
                <q-card flat bordered>
                    <q-card-section
                        class="item-label
                                q-px-none
                                q-py-sm
                                text-center
                                total-price-header
                                text-white
                                "
                    >

                        <div class="text-h6">
                            Payment Option
                        </div>
                    </q-card-section>
                    <q-separator inset class="q-ma-none"/>
                    <q-card-section class="item-label text-center q-pa-none">
                        <q-list bordered>
                            <q-item
                                tag="label"
                                v-ripple
                                class="q-px-none q-py-md payment-option"
                                :class="{activePayment:selectedPriceType ==='discounted'}"
                            >
                                <q-item-section avatar top class="q-pa-none">
                                    <q-icon
                                        name="check_circle_outline_icon"
                                        color="brand6"
                                        size="lg"
                                        class="selected-price-icon"
                                        v-if="selectedPriceType ==='discounted'"
                                    />
                                    <div v-else class="check-cirlce selected-price-icon"></div>
                                    <q-radio
                                        v-model="selectedPriceType"
                                        val="discounted"
                                        style="display:none"
                                    />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label
                                        class="text-bold"
                                    >
                                        Discounted Cash Price
                                    </q-item-label>
                                    <q-item-label
                                        caption
                                        class="price-type-info-text"
                                    >
                                        {{getSelectedPriceTypeInfo('discounted')}}
                                    </q-item-label>
                                </q-item-section>
                            </q-item>
                            <q-item
                                tag="label"
                                v-ripple
                                class="q-mt-xs q-px-none q-py-md payment-option"
                                :class="{activePayment:selectedPriceType ==='regular'}"

                            >
                                <q-item-section avatar top  class="q-pa-none">
                                    <q-icon
                                        name="check_circle_outline_icon"
                                        color="brand6"
                                        size="lg"
                                        class="selected-price-icon"
                                        v-if="selectedPriceType ==='regular'"
                                    />
                                    <div v-else class="check-cirlce selected-price-icon"></div>
                                    <q-radio
                                        v-model="selectedPriceType"
                                        val="regular"
                                        style="display:none"
                                    />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label
                                        class="text-bold"
                                    >
                                        Full Debit/Credit Charge
                                    </q-item-label>
                                    <q-item-label
                                        caption
                                        class="price-type-info-text"
                                    >
                                        {{getSelectedPriceTypeInfo('regular')}}
                                    </q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                        <span class="text-bold text-brand6 total-price">
                            {{ selectedPrice | currency }}
                        </span>
                    </q-card-section>
                    <q-separator inset class="q-ma-none"/>
                    <q-card-section
                        class="
                            item-label
                            row
                            space-around
                            items-center
                            no-wrap
                            "
                    >
                        <div>
                            <div class="row no-wrap items-center">
                                <div><span class="text-brand6 due-label">Due Now</span></div>
                                <q-icon
                                    name="info"
                                    class="text-grey-6 item-tooltip q-mr-md q-ml-sm"
                                >
                                    <q-tooltip
                                        max-width="200px"
                                        anchor="center right"
                                        self="center left"
                                    >
                                        {{chargeInfoNote}}
                                    </q-tooltip>
                                </q-icon>
                            </div>
                        </div>
                        <div>
                            <div class="row no-wrap items-center">
                                <span class="text-brand6 q-pr-xs due-value">$0</span>
                                <div class="due-info">
                                    Don't worry - you won't pay until your pickup is scheduled
                                </div>
                            </div>
                        </div>
                    </q-card-section>
                </q-card>
            </div>
            <div class="q-mt-md">
                <q-card bordered flat>
                    <q-card-actions  class="vehicles-header-box text-brand7 bg-grey-2">
                        <div class="text-h6">Vehicle Information</div>
                    </q-card-actions>
                    <q-slide-transition>
                        <div>
                            <q-separator />
                            <div v-if="vehicles && vehicles.length > 1">
                                <q-tabs
                                    v-model="vehicle_tab"
                                    dense
                                    class="text-grey"
                                    active-color="brand7"
                                    indicator-color="brand5"
                                    align="justify"
                                    narrow-indicator
                                >
                                    <q-tab
                                        :name="`vehicle${index+1}`"
                                        :label="`vehicle #${index+1}`"
                                        v-for="(vehicle, index) in vehicles"
                                        :key="index"
                                    />
                                </q-tabs>
                                <q-separator />
                            </div>
                            <q-tab-panels v-model="vehicle_tab" animated>
                                <q-tab-panel
                                    :name="`vehicle${index+1}`"
                                    v-for="(vehicle, index) in vehicles"
                                    :key="index"
                                >
                                    <q-list separator dense>
                                        <q-item
                                            v-for="(item,i) in items"
                                            :key="i" :class="i%2?`bg-grey-1`:``"
                                        >
                                            <q-item-section
                                                no-wrap class="item-label"
                                                :class="itemSectionClass"
                                            >
                                                {{item.label}}
                                            </q-item-section>
                                            <q-item-section
                                                avatar
                                                class="item-section-avatar"
                                                :class="itemSectionAvatarClass"
                                            >
                                                <q-icon
                                                    name="info"
                                                    class="item-tooltip"
                                                    v-if="item.tooltip"
                                                    color="grey" size="xs"
                                                >
                                                    <q-tooltip
                                                        max-width="200px"
                                                        anchor="center right"
                                                        self="center left"
                                                    >
                                                        {{item.tooltip}}
                                                    </q-tooltip>
                                                </q-icon>
                                            </q-item-section>
                                            <q-item-section no-wrap class="item-value">
                                                {{getItemValue(item, index)}}
                                            </q-item-section>
                                        </q-item>
                                    </q-list>
                                </q-tab-panel>

                            </q-tab-panels>
                        </div>
                    </q-slide-transition>
                </q-card>
            </div>
            <div class="q-mt-md">
                <q-card bordered flat>
                    <q-list separator dense>
                        <q-item class="items-center">
                            <q-item-section
                                no-wrap class="item-label"
                            >
                                Pick-Up Details
                            </q-item-section>

                            <q-item-section no-wrap class="item-value">
                                <q-item-label caption>
                                    {{origin.city}}, {{origin.state}}, {{origin.zipcode}}
                                </q-item-label>
                            </q-item-section>
                        </q-item>

                        <q-item>
                            <q-item-section
                                no-wrap class="item-label"
                            >
                                Delivery Details
                            </q-item-section>

                            <q-item-section no-wrap class="item-value" caption>
                                <q-item-label caption>
                                    {{destination.city}},
                                    {{destination.state}},
                                    {{destination.zipcode}}
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-card>
            </div>
    </div>
</template>
<script>

const items = [
    {
        label: 'Year',
        value: 'year',
        type: 'vehicle'
    },
    {
        label: 'Make',
        value: 'make',
        type: 'vehicle'
    },
    {
        label: 'Model',
        value: 'model',
        type: 'vehicle'
    },
    {
        label: 'Available Date',
        value: 'availableDate',
        type: 'transport',
        format: 'date',
        tooltip: 'Your first aviliable date is the first date we would try to pick up your vehicle. The majority of our customers get picked up within 1-4 days of their first aviliable date. If a certain time/ship date is a critical factor for your move, please call and ask about us getting you picked up by priority (price can vary based on date)'
    },
    {
        label: 'Carrier Type',
        value: 'carrierType',
        type: 'transport',
        tooltip: 'Open carrier is the most popular and cost effective method to transport vehicles. Most new vehicles from dealerships are transported on an open trailer.Enclosed Carrier protect vehicles from weather, dirt, and rock chips during transport. They are popular for high value or classic car vehicles'
    },
    {
        label: 'Service Type',
        value: 'Door To Door',
        type: 'static',
        tooltip: 'The car will be picked up and delivered as legally and safely possible to any residential and/or business address. Sometimes the driver may ask you to meet somewhere close to the address if his large truck can not get to the address. (Tight street, Low trees/wires, construction, ETC.)'
    },
    {
        label: 'Insurance',
        value: 'Included',
        type: 'static',
        tooltip: 'Your vehicles is insured from pickup to delivery with no deductible to you. Inspection report is given to receiving party at delivery.'
    }
];

const priceTypeInfo = {
    discounted: 'Once your order is assigned to a driver a partial payment of around $200.00 dollars will be charged. The remaining balance will be due on delivery in either CASH, CERTIFIED BANK CHECK, or MONEY ORDER.',
    regular: 'Once the order is assigned to a carrier, the full balance will be charged to your credit or debit card prior to pick up.'
};

const chargeInfoNote = `We charge a deposit once the
                    carrier is dispatched/Scheduled for your order.
                    Deposits are normally a charge from
                    $95.00 - $295.00 as this is to secure
                    a spot on the drivers truck.
                    The remaining balance is due upon delivery to the driver.
                    We will send a dispatch email/receipt with the remaining balance shown.`;
export default {
  name: 'AppBookOrderTransportDetails',
  props: {
    vehicles: Array,
    transport: Object,
    origin: Object,
    destination: Object,
    priceType: String,
    hidePriceBox: {
        type: Boolean,
        default: () => false
    }
  },
  computed: {
    itemSectionAvatarClass() {
      if (this.$q.screen.gt.sm) return 'justified-start';
      return '';
    },
    itemSectionClass() {
      if (this.$q.screen.lt.md) return { 'item-section-dense': true };
      return {};
    },
    priceTypeCapitalize() {
        return this.selectedPriceType === 'discounted' ?
            'Discounted' : 'Regular';
    },
    selectedPrice() {
        return this.selectedPriceType === 'discounted' ?
            this.transport.discountedPrice : this.transport.regularPrice;
    }
  },
  data() {
      return {
          items,
          chargeInfoNote,
          vehicle_tab: 'vehicle1',
          selectedPriceType: this.priceType
      };
  },
  methods: {
    getItemValue(item, i) {
    let v = '';
    if (item.type === 'static') v = item.value;
    else if (item.type === 'vehicle') v = this.vehicles[i][item.value];
    else if (item.type === 'transport') v = this.transport[item.value];
    if (item.format === 'date') v = this.$options.filters.usDateFormat(v);
    return v;
    },
    getSelectedPriceTypeInfo(priceType) {
        return priceTypeInfo[priceType];
    }
  },
    watch: {
      selectedPriceType: function (value) {
        if (value) {
            this.$emit('priceTypeChanged', value);
        }
      }
  }

};
</script>
<style lang="scss">

    .q-item__section.item-value{
        align-self: flex-end;
    }
    .q-list--dense>.q-item{
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .q-stepper__nav{
        display: flex;
        flex-direction: row-reverse;
        padding-top: 0;
    }
    .item-tooltip{
        cursor: pointer;
    }
    .q-item__section--side.item-section-avatar{
        padding-left: 2px;
        width: auto;
        flex-direction: row;
        &.justified-start{
            justify-content: flex-start;
        }
    }
    .item-section-dense{
        width: 100px;
    }

    .due-label{
        font-weight: bold;
        white-space: nowrap;
        font-size: 15px;
    }
    .due-value{
        font-size: 27px;
        font-weight: bold;
    }
    .due-info{
        font-size: 12px;
    }
    .total-price{
        font-size: 27px;
    }
    .q-tooltip,.q-tooltip--style{
        font-size: 12px !important;
        text-align: justify;
    }
    .total-price-header{
        background: linear-gradient(180deg, #359615, #3d3e3e);
    }
    .q-panel{
        height: auto;
    }
    .vehicles-header-box{
        cursor: pointer;
    }
    .price-type-info-text{
        font-size: 15px;
    }
    .payment-option{
        border: 1px solid var(--brand-6-color);
    }
</style>
